import React  from "react";
import { Show,
    TabbedShowLayout,
    Tab,
} from 'react-admin';
import {useResourceOptions} from "../../hooks";
import {Title} from "../Common/Title";
import {productStock,product} from "../../resources";
import {SubResourceList} from "../Common/SubResourceList";

export const ShowFinal = (props) =>
{
    const { readableFields, operations } = useResourceOptions(props.resource);
    return (
        <Show title={<Title resource={product.name}/>} {...props}>
            <TabbedShowLayout>
                <Tab label="Schedule">
                    <SubResourceList targetResource={productStock.name} recordType={'product'} location={props.location} id={props.id} match={props.match}/>
                </Tab>
            </TabbedShowLayout>
        </Show>
    );
};
